var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.reqs),function(req,key){return _c('div',{key:key,staticClass:"mt-8",class:{ 'text-green-500': req.isPassing }},[_c('i',{staticClass:"ml-16 mr-8 text-grey-500",class:{
        'text-green-500 fas fa-check': req.isPassing,
        'fas fa-minus': !req.isPassing,
      },attrs:{"aria-label":req.isPassing ? _vm.$t('common.passing') : _vm.$t('common.not_passing')}}),_c('span',[_vm._v(_vm._s(_vm.$t(req.text)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }